import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_search, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { remote_search_get_shared_by_id } from '@/state/search/remote_search_get_shared_by_id';
import { LOCAL__workspace_set_is_all_data_loaded } from '@/state/workspace/entity/LOCAL__workspace_set_is_all_data_loaded';
import { save_url_to_store_for_redirect_after_auth } from '@/utils/utils_client';
import { set_current_search, set_current_workspace, try_set_default_workspace } from '@/utils/utils_client_workspace_child_entity_viewers';
import { try_load_shared_search_from_server } from '@/utils/utils_shared_entity';
import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO_RESPONSE__success } from '@shared/network/DTO_RESPONSE__success';
import { useNavigate, useParams } from 'react-router-dom';

export function WatcherSlugPageSearch() {
  const dispatch = use_dispatch();
  const navigate = useNavigate();

  const { search_id: search_id_from_slug } = useParams();

  const { auth_token } = use_slice_user(['auth_token']);

  const { search_current, search_history_map } = use_slice_search(['search_history_map', 'search_current']);
  const { is_all_data_loaded, workspace_current } = use_slice_workspace(['is_all_data_loaded', 'workspace_current']);

  /*
   * EFFECTS
   */
  use_effect(() => void set_entity_and_workspace_from_slug(), [is_all_data_loaded]);

  use_effect(() => void load_shared_entity_for_guest(), [auth_token]);

  use_effect(() => {
    if (!is_all_data_loaded) return;

    //could be stub when from user deleted permissions to view entities
    let entity_id = search_current.is_stub() ? '' : search_current._id;

    //sync slug with redux
    void navigate(ENUM__page_type.BUILD_PATH_SEARCH(entity_id), { replace: true });
  }, [is_all_data_loaded, search_current]);

  /*
   * METHODS
   */

  async function set_entity_and_workspace_from_slug() {
    if (!auth_token) return; //not authorized
    if (!is_all_data_loaded) return; // not all data loaded

    //already equal
    if (search_current._id === search_id_from_slug && !search_current.is_stub()) return set_current_workspace(search_current.workspace_id);
    if (!search_current.is_stub()) return; //already established

    let entity_from_slug = [...search_history_map.values()].find(item => item._id == search_id_from_slug);

    if (!entity_from_slug && search_id_from_slug) {
      entity_from_slug = await try_load_shared_search_from_server(search_id_from_slug);
    }

    if (entity_from_slug) {
      await set_current_search(entity_from_slug._id);

      set_current_workspace(entity_from_slug.workspace_id);
    } else if (workspace_current.is_stub()) {
      await try_set_default_workspace();
    }
  }

  async function load_shared_entity_for_guest() {
    if (auth_token) return; //user is authorized or going to authorize
    if (!search_current.is_stub()) return; //already establshed

    if (!search_id_from_slug) {
      //page without params
      //need save it and navigate to auth
      save_url_to_store_for_redirect_after_auth();

      await navigate(ENUM__page_type.AUTH);

      return;
    }

    //page without params should has LayoutOpenAuthIfNoAuthToken
    assert_string_not_empty(search_id_from_slug);

    let action_result = await dispatch(remote_search_get_shared_by_id(search_id_from_slug));

    if (action_result.payload instanceof DTO_RESPONSE__success) {
      let search_current = await set_current_search(search_id_from_slug);

      set_current_workspace(search_current.workspace_id);

      dispatch(LOCAL__workspace_set_is_all_data_loaded(true));
    } else {
      save_url_to_store_for_redirect_after_auth();

      await navigate(ENUM__page_type.AUTH);
    }
  }

  return <></>;
}
